/**
 * Tiny pub/sub bridging the search box → the active search tab's label, so the
 * tab "writes itself" letter-by-letter as you type (SearchInput broadcasts,
 * SearchTabs subscribes). `null` = not editing (tab shows its committed label).
 */
type Listener = (value: string | null) => void;

let draft: string | null = null;
const listeners = new Set<Listener>();

export function setSearchDraft(value: string | null): void {
  draft = value;
  for (const l of listeners) l(value);
}

export function getSearchDraft(): string | null {
  return draft;
}

export function subscribeSearchDraft(l: Listener): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}
